import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import asyncComponent from '../../util/AsyncFunc';

import AddMail from './addmail/index'
import MailList from './maillist/index'

const Mail = ({ match }) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/mail-list`} />
            <Route path={`${match.url}/add-mail/:id?`} component={AddMail} />
            <Route path={`${match.url}/mail-list`} component={MailList} />
        </Switch>
    </div>
);

export default Mail;



// WEBPACK FOOTER //
// ./app/maildetails/index.js